@for (alert of alerts(); track alert.pageAlertId) {
  <div class="alert d-flex align-items-center" [ngClass]="getAlertClass(alert)" role="alert">
    <div markdown [data]="alert.description"></div>
  </div>
}
